import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  AccountPageAction,
  changePasswordBegin,
  loginWithEmail,
  resetPasswordBegin,
  resetPasswordFailure,
  resetPasswordSuccess,
} from './actions'
import { AccountPageState } from './types'

export const accountPageReducer = combineReducers<AccountPageState, AccountPageAction>({
  isLoading: (_, action) => {
    switch (action.type) {
      case getType(loginWithEmail.request):
      case getType(changePasswordBegin):
      case getType(resetPasswordBegin):
        return true
      default:
        return false
    }
  },
  emailAuthError: (emailAuthError = '', action) => {
    switch (action.type) {
      case getType(loginWithEmail.request):
      case getType(loginWithEmail.success):
        return ''
      case getType(loginWithEmail.failure):
        // TODO: Make custom error messages
        return 'error'
      default:
        return emailAuthError
    }
  },
  resetAuthError: (resetAuthError = '', action) => {
    switch (action.type) {
      case getType(resetPasswordBegin):
      case getType(resetPasswordSuccess):
        return ''
      case getType(resetPasswordFailure):
        // TODO: Make custom error messages
        return 'error'
      default:
        return resetAuthError
    }
  },
})
